import React from "react";
import {MdOutlineKeyboardBackspace} from 'react-icons/md'
import { useNavigate } from "react-router-dom";
import { useMenuBack } from "../hooks/useMenuBack";



  const BackComponent = ({title,url,onBack}:any) => {
    const history = useNavigate();
    // No explicit url → go to the page's MENU PARENT (never browser history).
    const menuBack = useMenuBack();
    const goBack = () => {
      if (onBack) { onBack(); return; }
      url ? history(url) : menuBack();
    };
    return (
      <>
        <div className="back-nav">
          <div className="flex items-center">
            { (
              <a onClick={goBack} href="javascript:void(0)" className="left-arrow mr-3">
               <MdOutlineKeyboardBackspace  size={24}/>
              </a>
            )}
            <div className="page-title">
              {title}
            </div>
          </div>
        </div>
      </>
    );
  };

  export default BackComponent;